import type { UseFormGetValues } from "react-hook-form";
import type { LeadResponse } from "~www/types/forms/lead-response";
import type {
  FranchiseInquiryFormInput,
  FranchiseInquiryResponse,
} from "./franchiseInquiry.schema";

type FranchiseSubmitResult = "success" | "server-error" | "validation-error";

function getFranchiseInquiryTrackingProperties(
  result: FranchiseSubmitResult,
  getFormValues: UseFormGetValues<FranchiseInquiryFormInput>,
  tags: LeadResponse<FranchiseInquiryResponse>["tags"],
) {
  return {
    county: getFormValues("county"),
    email: getFormValues("email"),
    first_name: getFormValues("firstName"),
    form_submission_result: result,
    last_name: getFormValues("lastName"),
    marketing_opt_in: getFormValues("marketingOptIn"),
    message: getFormValues("message"),
    phone: getFormValues("phone"),
    postcode: getFormValues("postcode"),
    tags,
  };
}

export { getFranchiseInquiryTrackingProperties };
